import { useHits } from 'react-instantsearch-hooks-web';
import SortFacet from '../facets/sort';
import { useFormat } from '@/helpers/hooks/useFormat';
import { useLocalizedIndex } from '@/providers/localized-index';

const DesktopSortFacets = () => {
  const { indexName: productsIndex } = useLocalizedIndex({ type: 'products' });

  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });
  const sortValues = [
    {
      label: formatProductMessage({ id: 'new-products', defaultMessage: 'New' }),
      value: productsIndex,
    },
    {
      label: formatProductMessage({ id: 'nameAsc', defaultMessage: 'Name A-Z' }),
      value: productsIndex.replace('_created_desc', '') + '_name_asc',
    },
    {
      label: formatProductMessage({ id: 'nameDsc', defaultMessage: 'Name Z-A' }),
      value: productsIndex.replace('_created_desc', '') + '_name_desc',
    },
    {
      label: formatProductMessage({ id: 'Price Low to High', defaultMessage: 'Price Low to High' }),
      value: productsIndex.replace('_created_desc', '') + '_price_asc',
    },
    {
      label: formatProductMessage({ id: 'priceDsc', defaultMessage: 'Price High to Low' }),
      value: productsIndex.replace('_created_desc', '') + '_price_desc',
    },
    {
      label: formatProductMessage({ id: 'Exclusive Product', defaultMessage: 'Exclusive Product' }),
      value: productsIndex.replace('_created_desc', '') + '_exclusive_desc',
    },
    {
      label: formatProductMessage({ id: 'Coming Soon', defaultMessage: 'Coming Soon' }),
      value: productsIndex.replace('_created_desc', '') + '_prototype_desc',
    },
  ];

  return (
    <div className="">
      <SortFacet items={sortValues} />
    </div>
  );
};

export default DesktopSortFacets;
